const Status = {
    INVITED: 'INVITED',
    PENDINGAPPROVAL: 'PENDINGAPPROVAL',
    APPROVED: 'APPROVED',
    INACTIVE: 'INACTIVE'
};

const ButtonText = {
    INVITED: 'Re-Invite',
    PENDINGAPPROVAL: 'Approve',
    APPROVED: 'Active',
    INACTIVE: 'Inactive'
};

const FilterText = {
    INVITED: 'Invited',
    PENDINGAPPROVAL: 'Pending Approval',
    APPROVED: 'Active',
    INACTIVE: 'Inactive'
};

export { Status, ButtonText, FilterText };